@if (data.activeDealer; as activeDealer) {
  <div class="change-dealer-dialog">
    <p>Endre aktiv dealer</p>
    @if (data.dealers; as dealers) {
      <mat-form-field appearance="outline" class="form-field-with-background ice-custom-mat-select">
        <mat-select
          name="dealers"
          placeholder="Aktiv dealer"
          [ngModel]="activeDealer.dealerId"
          (selectionChange)="onChangeDealer($event)"
        >
          <div class="ice-custom-mat-options">
            @for (dealer of dealers; track dealer.dealerId) {
              <mat-option [value]="dealer.dealerId">
                {{ dealer.displayName }}
              </mat-option>
            }
          </div>
        </mat-select>
      </mat-form-field>
    }
  </div>
}
